import { EntityType } from '@exam-management/graphql';
import {
  QuestionCommentProvider,
  useQSetReviewSubtask,
  QSetReviewSubtaskExamDetailsPageHeader,
} from '@exam-management/qset-review-subtask-details';
import { useParams } from '@exam-management/router';
import { Outlet } from 'react-router-dom';

export default function ExamDetailsLayout() {
  const { subTaskId } = useParams(
    '/my-task/qset-review/:taskId/subtask/:subTaskId/task-details/exam-details',
  );
  const {
    qSetQuestion: { currentQuestion },
  } = useQSetReviewSubtask();

  return (
    <QuestionCommentProvider
      taskId={subTaskId}
      entityId={currentQuestion?.id}
      entityType={EntityType.Question}
    >
      <QSetReviewSubtaskExamDetailsPageHeader />
      <Outlet />
    </QuestionCommentProvider>
  );
}
